import { GlobalState } from "../../utils/types";

export const userPermissionSelector = (state: GlobalState) => state.user.me.permissions;
export const usersListSelector = (state: GlobalState) => state.user.users;
export const authUserSelector = (state: GlobalState) => state.user.me;
